export default function getDefaultParamsPage() {
  return {
    PAGE_ROUTE: location.pathname,
    PAGE_URL: location.href
  };
}
//# sourceMappingURL=get-default-params-page.js.map